import React, { Fragment } from "react";
import styled from "styled-components";
import InputText from "./InputText";
import Button from "../Button/Button";

const Input = (props) => {
  const {
    state,
    title_view,
    title,

    input_view,
    input_type,
    input_text_style,
    input_pattern,
    input_disable,
    input_placeholder,
    input_defaultValue,
    input_onChange,
    input_rIconView,
    input_rIcon,
    input_rIconEvent,

    button_view,
    button_severity,
    button_disable,
    button_small,
    button_event,
    button_text,
    button_style,

    enterEvent,
  } = props;
  return (
    <Container>
      {title_view && (
        <Header style={props.titleStyle ? props.titleStyle : {}}>
          {title}
        </Header>
      )}
      <Body>
        <InputText
          state={state}
          type={input_type}
          inputStyle={input_text_style ? input_text_style : {}}
          pattern={input_pattern}
          disable={input_disable}
          placeholder={input_placeholder}
          defaultValue={input_defaultValue}
          onChange={input_onChange}
          rIconView={input_rIconView}
          rIcon={input_rIcon}
          rIconEvent={input_rIconEvent}
          enterEvent={enterEvent}
        />

        {/* 전화번호 입력되면 disable="off" */}
        {button_view && (
          <Button
            severity={button_severity}
            disable={button_disable}
            small={button_small}
            clickEvent={button_event}
            buttonStyle={button_style}>
            {button_text}
          </Button>
        )}
      </Body>
    </Container>
  );
};

/* SAMPLE

<Input 
  title_view=<boolean>
  title=<string>
  input_type=<string>
  input_placeholder=<string>
  input_onChange=<void>
  button_view=<boolean>
  button_severity=<string>
  button_disable=<string>
  button_small=<boolean>
  button_event=<boid>
  button_text=<string>
/>

*/

const Container = styled.div`
  display: inline-flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const Header = styled.div`
  display: flex;
  width: 320px;
  align-items: flex-start;
  color: #333333;
`;

const Body = styled.div`
  display: flex;
  /* align-items: flex-start; */
  gap: 8px;
  align-self: stretch;
`;

export default Input;
